import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { info } from 'react-icons-kit/fa/info';
import { close } from 'react-icons-kit/fa/close';
import { ic_remove_red_eye } from 'react-icons-kit/md/ic_remove_red_eye';
import { ic_visibility_off } from 'react-icons-kit/md/ic_visibility_off';
import { quill } from 'react-icons-kit/icomoon/quill';
import Slider from 'react-rangeslider';
import ReactTooltip from 'react-tooltip';

import CheckBox from 'components/CheckBox/CheckBox';
import ActionButton from 'components/ActionButton/ActionButton';
import { isCustomWMSLayerActive, getCustomWMSLayerOpacity, } from 'utils/Visor';

import './TableRow.css';

declare var CONFIGURATIONS;

class TableRow extends Component {
  constructor(props) {
    super(props);
    this.state = { value: getCustomWMSLayerOpacity(this.props.data.split('.')[0])*10 };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      this.setState({ value: getCustomWMSLayerOpacity(nextProps.data.split('.')[0])*10 });
    }
  }

  handleChange = (newValue) => {
    this.props.changeOpacity(newValue/10);
    this.setState({ value: newValue });
  }

  render() {
    const { t, data, isSelected, select, showInfoPopup, deleteFotogram, openHideFotogram, certifyFotogram, flight } = this.props;
    const opened = isCustomWMSLayerActive(data);
    const name = data;

    return (
      <tr className='tableRow'>
        <td className='tableRowCell cellCheckbox'>
          <CheckBox id={'tableRowCB' + data} onClick={select} isSelected={isSelected} />
        </td>
        <td className='tableRowCell tableRowFotogramName' data-tip data-for={name + 'tooltip'} >
          {name}
          <ReactTooltip id={name + 'tooltip'} effect='solid' place='right'>
            <div>
              <p>{t('tableRow.fotogram')}: <b>{name}</b></p>
              <p>{t('tableRow.flight')}: <b>{flight.title}</b></p>
            </div>
          </ReactTooltip>
        </td>
        <td className='tableRowCell opacity'>
          { opened ?
            <Slider min={0} max={10} step={1} orientation='horizontal'
              value={this.state.value} tooltip={false} onChange={this.handleChange} />
          : <span>-</span>}
        </td>
        <td className='tableRowCell buttons'>
          <div className='buttonsContainerTableRow'>
            <ActionButton id={'tableRowShow' + data} icon={opened === false ? ic_visibility_off : ic_remove_red_eye} size={'18px'} color={'#fda823'} tooltip={opened === false ? t('tableRow.show') : t('tableRow.hide')} onClick={openHideFotogram} />
            <ActionButton id={'tableRowInfo' + data} icon={info} size={'18px'} color={'#fda823'} tooltip={t('tableRow.info')} onClick={showInfoPopup} />
            <ActionButton id={'tableRowPrint' + data} icon={quill} size={'18px'} color={'#235FA6'} tooltip={t('tableRow.certify')} onClick={certifyFotogram} />
            <ActionButton id={'tableRowDelete' + data} icon={close} size={'18px'} color={'#ff0000'} tooltip={t('tableRow.delete')} onClick={deleteFotogram} />
          </div>
        </td>
      </tr>
    );
  }
}

export default translate()(TableRow);
